import React from 'react';
export var FlocktoryAnalytics = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$isOutOfStock = _ref.isOutOfStock,
    isOutOfStock = _ref$isOutOfStock === void 0 ? '' : _ref$isOutOfStock,
    _ref$categoryId = _ref.categoryId,
    categoryId = _ref$categoryId === void 0 ? '' : _ref$categoryId,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? '' : _ref$id,
    _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? '' : _ref$brand;
  return /*#__PURE__*/React.createElement("div", {
    className: "i-flocktory",
    "data-fl-action": "track-item-view",
    "data-fl-item-available": !isOutOfStock,
    "data-fl-item-category-id": categoryId,
    "data-fl-item-id": id,
    "data-fl-item-vendor": brand
  });
});